/* ============
 * Checkout v2 Store
 * ============
 */

import { defineStore } from 'pinia';
import './pinia';

export const useCheckoutV2Store = defineStore('checkoutv2', {
  state: () => ({
    placeInfos: null,
    lastPlaceInfos: null,
    description: null,
    lastPricing: null,
    summaryInfos: null,
    paymentMethods: null,
    templates: [],
    lastSelectedTemplate: null,
    templateSelectedId: null,
    fromQuoteId: null,
  }),

  actions: {
    storePlaceInfos(data) {
      this.placeInfos = data;
      this.lastPlaceInfos = data;
    },

    storeDescription(data) {
      this.description = data;
    },

    storeLastPricing(data) {
      this.lastPricing = data;
    },

    storeSummaryInfos(data) {
      this.summaryInfos = data;
    },

    storePaymentMethods(data) {
      this.paymentMethods = data;
    },

    storeTemplates(data) {
      this.templates.push(data);
    },

    storeLastSelectedTemplate(data) {
      this.lastSelectedTemplate = data;
    },

    storeTemplateSelectedId(id) {
      this.templateSelectedId = id;
    },

    storeFromQuoteId(id) {
      this.fromQuoteId = id;
    },

    clear() {
      this.description = null;
      this.placeInfos = null;
      this.summaryInfos = null;
      this.paymentMethods = null;
      this.templates = [];
      this.templateSelectedId = null;
      this.fromQuoteId = null;
    },
  },
});

export default useCheckoutV2Store;
